

























import { Vue, Component, Prop } from 'vue-property-decorator'
declare function require(img: string): string
@Component({
  name: 'AccessCard'
})
export default class extends Vue {
  @Prop({ required: true }) icon!: string
  @Prop({ required: true }) title!: string
  @Prop({ required: true }) number!: number
  @Prop({ required: true }) id!: string

  get src() {
    let list: string[] = ['mobilealipay', 'paymentwall', 'paypal', 'stripe', 'wechat']
    if (this.icon === '') {
      return ''
    } else if (this.icon.startsWith('http')) {
      return this.icon
    } else if (list.includes(this.icon)) {
      return require('./icon/' + this.icon + '.svg')
    } else {
      return ''
    }
  }
}
